module.exports = __webpack_public_path__ + "static/media/21ECLAC13.6db753fb.jpg";